import { ImCheckboxChecked, ImCheckboxUnchecked } from "react-icons/im"
import { useRenterDashboardContext } from "./useRenterDashboardContext"
import { UploadImageField } from "../../../../common/components/form/UploadImageField/UploadImageField"
import { brDateHourFormat } from "../../../../common/helpers/date.helpers"

const ASSETS_URL = import.meta.env.VITE_ASSETS_URL
const buildAssetURL = (key: string) => {
  return key ? `${ASSETS_URL}/${key}` : "<span>Enviar arquivo</span>"
}
export function DocumentsInfo() {
  const getImageUrl = (content) => {
    if (content &&
      content.startsWith("https://ileva.s3.sa-east-1.amazonaws.com" &&
        content.includes("https://assets.locavibe.com.br/https://ileva.s3.sa-east-1.amazonaws.com"))) {
      return buildAssetURL(content)
    }
    return content
  }

  const { renter } = useRenterDashboardContext();
  return (

    <div className="tabs-border-line">
      {/* Documentos */}
      <section className="tabs-item-style">
        <h2 className="text-2xl font-semibold mb-4">Documentos</h2>
        <section className="grid grid-cols-1 gap-1">
          {renter.documents && renter.documents.map((document, index) => (

            <div className={`mb-4 px-2 py-4 ${index % 2 !== 0 ? 'bg-gray/5' : 'bg-gray/40 rounded'}`} key={index}>
              <h2 className="font-semibold text-sm">Tipo de Documento:</h2>
              <div className="flex items-center">
                <p className="border border-slate-500 text-gray3 h-[34px] min-w-[60%] px-2 py-1 mr-3 rounded bg-white/50">{document.type}</p>
                <div className="flex flex-wrap items-center">
                  <div className="w-24 h-24 bg-gray/40">
                    {document.content === ''
                      ? <span
                        className="w-full h-full font-semibold flex items-center text-center border border-gray border-dashed text-[#443636] bg-white/50 rounded">Envie um arquivo!</span>
                      : <UploadImageField src={getImageUrl(document.content)} disableTrashIcon={true} />}
                  </div>
                  <div className="mx-2">
                    {document.verified ? (
                      <div className="text-greenPrimary text-md flex flex-row items-center">
                        <ImCheckboxChecked />
                        <span>Verificado</span>
                      </div>
                    ) : (
                      <div className="text-redPrimary text-sm flex flex-row items-center">
                        <ImCheckboxUnchecked />
                        <span>Não verificado</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </section>
      </section>

      <div className="div-tabs-border-line"></div>

      <section className="tabs-item-style">
        <h2 className="font-semibold text-2xl mb-4">Observações</h2>
        <div className="w-full min-h-[80px] border border-gray/40 shadow-md rounded bg-white/60 p-2">
          <section>
            {renter?.observations?.slice().reverse().map((observation, index) => (
              <div key={index} className="w-full bg-gray/10 my-4 p-2 rounded-md border border-gray/40">
                <label className="font-semibold">{brDateHourFormat(observation.date)}</label>
                <p className="whitespace-pre-wrap"><h3 className="font-semibold">Observação:</h3>{observation.text}</p>
                <br />
                <p className="font-semibold">Criado por: {observation.author}</p>
              </div>
            ))}
          </section>

        </div>
      </section>
    </div>
  )
}
export default DocumentsInfo